import React from 'react';
import { Anchor, AnchorProps } from '../Typography';

export interface BreadcrumbLinkProps extends AnchorProps {
    /**
     * If `true`, the item will be in the active state.
     * @default false
     */
    active?: boolean;

    /**
     * If `true`, the item will be in the disabled state.
     * @default false
     */
    disabled?: boolean;

    /**
     * Callback fired when the element has been clicked.
     * @param {React.SyntheticEvent} event The event source of the callback.
     */
    onClick?: (event: React.SyntheticEvent) => void;
}

export const BreadcrumbLink = React.forwardRef(function BreadcrumbLink(
    props: BreadcrumbLinkProps,
    ref: React.ForwardedRef<HTMLElement>
): React.JSX.Element {
    const { active = false, children, disabled = false, href, onClick, ...other } = props;

    const isLink = href && !(active || disabled);

    return (
        <Anchor
            ref={ref}
            component={isLink ? 'a' : 'span'}
            href={isLink ? href : undefined}
            onClick={onClick}
            weight={active ? 'bold' : 'regular'}
            underline={isLink ? 'hover' : 'none'}
            itemProp="item"
            itemType="http://schema.org/Thing"
            itemID={href}
            {...other}
        >
            <span itemProp="name">{children}</span>
        </Anchor>
    );
});
